<template>
  <div v-click-outside="hideDropdown">
    <hr>
    <div class="uk-width-1-1 filter-heading">
      <span class="filter-title uk-text-bottom">{{filterTitle}}</span>
      <span v-if="filterGroup.title !== 'Standards'">
              <span v-if="!expanded" class="see-more-triangle uk-float-right uk-text-top"
                    uk-icon="icon: triangle-down; ratio: 1.50" @click="setExpanded"></span>
      <span v-else class="see-more-triangle uk-float-right uk-text-top" uk-icon="icon: triangle-up; ratio: 1.50"
            @click="setExpanded"></span>
      </span>
    </div>
    <div v-if="filterGroup.title === 'Standards'">
      <div v-if="!edgateError">
        <autocomplete-dropdown
          :options="getStandards"
          :placeholder="$t('uploadDetailsInput.standardsPlaceholder')"
          v-on:multiCheckList="submitStandard"
          :multiSelection="false"
          :selectedStandard="selectedStandard"
          :clearSelection="selectedStandard.length === 0">
        </autocomplete-dropdown>

        <div v-if="selectedStandard.length" style="margin-top: 16px">
          <span class="filter-title uk-text-bottom">{{$t('general.strands')}}</span>
          <strands-dropdown
            :clearSelection="clearStrands"
            :fetch-complete="fetchComplete"
            :limit="strandsLimit"
            :message="$t('uploadDetailsInput.message.strands')"
            :multiSelection="true"
            :options="resolveStrands"
            :placeholder="$t('uploadDetailsInput.strandsPlaceholder')"
            v-on:strandSelected="resolveSelectedStrands"
            v-on:strandSearch="performStrandSearch">
          </strands-dropdown>
        </div>
      </div>
      <div v-else class="standards-error-box">
        <div class="error-heading">
          <img class="warning-icon-container uk-align-left" :data-src="WARNING" uk-img>
          <span>{{$t('filters.standardsError')}}</span>
        </div>
        <div class="error-message">
          <span>{{$t('filters.standardsErrorMessage')}}</span>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="!expanded">
        <div v-for="filter in displayFilters" class="options-padding">
        <span v-if="!filter.selected" class=" uk-text-middle add-pointer"
              @click="handleFilterUpdate(filters, filter.id, filterGroup.title)"><img :data-src="STD_UNCHECKED_BOX"
                                                                                      class="std-checkbox"
                                                                                      uk-img></span>
          <span v-else class="uk-text-middle add-pointer"
                @click="handleFilterUpdate(filters, filter.id, filterGroup.title)"><img :data-src="STD_CHECK_BOX"
                                                                                        class="std-checkbox"
                                                                                        uk-img></span>
          <img v-if="resolveIcon(filter.id)" class="add-pointer" :src="resolveIcon(filter.id)"
               @click="handleFilterUpdate(filters, filter.id, filterGroup.title)"/>
          <span v-if="defaultLang">
          <span class="filter-options add-pointer" @click="handleFilterUpdate(filters, filter.id, filterGroup.title)">{{filter.title}}</span>
        </span>
          <span v-else>
               <span v-if="filter.altTitle" class="filter-options add-pointer"
                     @click="handleFilterUpdate(filters, filter.id, filterGroup.title)">{{filter.altTitle}}</span>
              <span v-else class="filter-options add-pointer"
                    @click="handleFilterUpdate(filters, filter.id, filterGroup.title)">{{filter.title}}</span>
            </span>
        </div>
      </div>
      <div v-else v-bind:id=filterGroup.title class="select-filters-container bottom-margin overlay">
        <div v-for="filter in filterGroup.items">
          <div class="select-filters" @click="handleFilterUpdate(filters, filter.id, filterGroup.title)">
          <span v-if="filter.selected">
            <span class="uk-text-middle add-pointer"><img :data-src="LRG_CHECKED_BOX" class="lrg-checkbox"
                                                          uk-img></span>
            <img v-if="filterGroup.title === RESOURCE_TYPE && filter.id !== 'all'" :data-src="resolveIcon(filter.id)"
                 class="activity-icons" uk-img>
            <span v-if="defaultLang" class="filter-options add-pointer uk-text-bold">{{filter.title}}</span>
            <span v-else>
               <span v-if="filter.altTitle" class="filter-options add-pointer uk-text-bold">{{filter.altTitle}}</span>
              <span v-else class="filter-options add-pointer uk-text-bold">{{filter.title}}</span>
            </span>
          </span>
            <span v-else>
            <span class="uk-text-middle add-pointer"><img :data-src="LRG_UNCHECKED_BOX" class="lrg-checkbox"
                                                          uk-img></span>
            <img v-if="filterGroup.title === RESOURCE_TYPE && filter.id !== 'all'" :data-src="resolveIcon(filter.id)"
                 class="activity-icons" uk-img>
            <span v-if="defaultLang" class="filter-options add-pointer">{{filter.title}}</span>
                        <span v-else>
               <span v-if="filter.altTitle" class="filter-options add-pointer">{{filter.altTitle}}</span>
              <span v-else class="filter-options add-pointer">{{filter.title}}</span>
            </span>
          </span>
          </div>
        </div>
      </div>
      <span v-if="!expanded" class="see-more-text" @click="setExpanded">+ {{$t('general.seeMore')}}</span>
      <span v-else class="see-more-text" @click="setExpanded">- {{$t('general.seeLess')}}</span>
    </div>
  </div>
</template>

<script>
    import {mapMutations, mapActions, mapGetters} from 'vuex'
    import iconUtil from '../../../../utils/icon-util'
    import ClickOutside from 'vue-click-outside'
    import * as event from '../../../../enums/mixpanel-event'
    import * as grades from '../../../../enums/grades'
    import * as subjects from '../../../../enums/subjects'
    import * as contentType from '../../../../enums/content-type'
    import * as misc from '../../../../enums/misc'
    import gradeUtil from '../../../../utils/grade-util'
    import selectedFilters from '../../../../utils/selected-filters-util'
    import mixpanel from '../../../../services/mixpanel'
    import * as countryCode from '../../../../enums/supported-countries'
    import edgate from '../../../../services/smart-edgate'
    import AutocompleteDropdown from '../../../ui-components/autocomplete-dropdown/autocomplete-dropdown'
    import StrandsDropdown from '../../../ui-components/strands-dropdown/strands-dropdown'
    import * as _ from 'lodash'

    export default {
      name: 'new-desktop-filters',
      components: {
        StrandsDropdown,
        AutocompleteDropdown
      },
      props: ['filters', 'filter'],
      data() {
        return {
          expanded: false,
          dropdownClicked: false,
          selectedOptions: this.selectedFilterCount,
          ALL_FILTER_ID: 'all',
          STD_CHECK_BOX: iconUtil.resolve(misc.STD_CHECKED),
          STD_UNCHECKED_BOX: iconUtil.resolve(misc.STD_UNCHECKED),
          LRG_CHECKED_BOX: iconUtil.resolve(misc.LRG_CHECKED),
          LRG_UNCHECKED_BOX: iconUtil.resolve(misc.LRG_UNCHECKED),
          WARNING: iconUtil.resolve(misc.ERROR_INFO_ICON),
          RESOURCE_TYPE: contentType.CONTENT_TYPE_TITLE,
          strandsLimit: 10,
          strands: [],
          fetchComplete: true,
          clearStrands: false,
          edgateError: false
        }
      },
      methods: {
        ...mapMutations(['updateFilters', 'setSelectedStandard', 'setStrands', 'setSelectedStrands']),
        ...mapActions(['updateSelectedFilters', 'setDefaultFilterGroup', 'resolveUserLocation']),
        setExpanded() {
          if (this.expanded) {
            this.expanded = false
          } else {
            this.expanded = true
          }
                // required to get the clickOutside directive to function
          this.dropdownClicked = true
          setTimeout(() => {
            this.dropdownClicked = false
          }, 100)
        },
        resolveIcon(type) {
          switch (type) {
            case contentType.ACTIVITY:
              return iconUtil.resolve(contentType.ACTIVITY)
            case contentType.LESSON:
              return iconUtil.resolve(contentType.LESSON)
            case contentType.ASSESSMENT:
              return iconUtil.resolve(contentType.ASSESSMENT)
            case contentType.TEMPLATE:
              return iconUtil.resolve(contentType.TEMPLATE)
            case contentType.CLASSROOM_TOOLS:
              return iconUtil.resolve(contentType.TEACHING_TOOL)
            default:
              return null
          }
        },
        handleFilterUpdate(filters, filterId, filterGroup) {
          if (filterId === this.ALL_FILTER_ID) {
            this.setDefaultFilterGroup({filters: filters, filterGroup: filterGroup})
          } else {
            this.updateSelectedFilters({filters: filters, filterId: filterId, filterGroup: filterGroup})
          }
          mixpanel.track(
                    event.FILTER_UPDATE, {
                      grades: this.resolveGrades(),
                      subjects: this.resolveSubjects(),
                      contentType: this.resolveContentType()
                    })
        },
        hideDropdown() {
          if (!this.dropdownClicked) {
            if (this.expanded) {
              this.expanded = false
            }
          }
        },
        resolveGrades() {
          let selectedGrades = ''
          try {
            let gradeFilters = this.resolveFilter(grades.GRADES_TITLE)
            for (let grade of gradeFilters) {
              selectedGrades = selectedGrades + ' ' + gradeUtil.resolve(grade)
            }
            return selectedGrades
          } catch (err) {
            return null
          }
        },
        resolveSubjects() {
          let selectedSubjects = ''
          try {
            let subjectFilters = this.resolveFilter(subjects.SUBJECTS_TITLE)
            for (let subject of subjectFilters) {
              selectedSubjects = selectedSubjects + ' ' + subject
            }
            return selectedSubjects
          } catch (err) {
            return null
          }
        },
        resolveFilter(filterGroup) {
          let filters = selectedFilters.resolve(this.filters)
          if (filters.find(o => o.filterGroup === filterGroup).selectedFilters.length) {
            return filters.find(o => o.filterGroup === filterGroup).selectedFilters
          } else {
            return null
          }
        },
        resolveContentType() {
          let selectedContentType = ''
          try {
            let contentTypeFilters = this.resolveFilter(contentType.CONTENT_TYPE_TITLE)
            for (let type of contentTypeFilters) {
              selectedContentType = selectedContentType + ' ' + type
            }
            return selectedContentType
          } catch (err) {
            return null
          }
        },
        resolveCountryId() {
          if (this.getUserLocation.countryCode !== 'GB') {
            return countryCode.SUPPORTED_COUNTRIES.find(o => o.countryCode === this.getUserLocation.countryCode).ID
          } else {
                    // users country is part of the uk, determine which region
            return countryCode.SUPPORTED_COUNTRIES.find(o => o.regionName === this.getUserLocation.regionName).ID
          }
        },
        submitStandard(standard) {
          let standardId = this.getStandards.find(x => x.title === standard[0]).id
          this.setSelectedStandard(standardId)
          this.setStrands(null)
          this.fetchComplete = false
          this.resolveClearStrands()
          if (standardId !== 'none') {
            this.strandSearch(1, standardId)
          }
        },
        performStrandSearch(q) {
          let standardId = this.getStandards.find(x => x.selected === true).id
          this.fetchComplete = false
          this.submitStrand(q, standardId, this.strandSearch)
        },
        submitStrand: _.debounce((q, id, strandSearch) => {
          edgate.cancelSearch()
          strandSearch(q, id)
        }, 1000),
        strandSearch(q, id) {
          edgate.search(null, null, id, q)
                    .then(response => {
                      this.strands = []
                      let json = JSON.parse(response.text)
                      for (let result of json.results) {
                        let strand = {
                          title: result.standard_number + '  ' + result.standard_text,
                          id: result.guid,
                          standard: result.standard_number,
                          description: result.standard_text,
                          selected: false
                        }
                        this.strands.push(strand)
                      }
                      this.fetchComplete = true
                    }).catch(() => {
                      this.edgateError = true
                      this.fetchComplete = true
                    })
        },
        resolveClearStrands() {
          this.clearStrands = true
          setTimeout(() => {
            this.clearStrands = false
          }, 250)
        },
        resolveSelectedStrands(guids) {
          this.strands.map(strand => {
            if (guids.includes(strand.id)) {
              strand.selected = true
            } else {
              strand.selected = false
            }
          })
          this.setStrands(this.strands)
        }
      },
      computed: {
        ...mapGetters(['getUserLocation', 'getStandards', 'getStrands']),
        filterGroup() {
          return this.filters.find(o => o.title === this.filter)
        },
        selectedFilterCount: {
          get: function () {
            return this.filterGroup.items.filter(f => f.selected).length
          }
        },
        displayFilters() {
          let displayFilterArr = []
          let displayCount = 0
          for (let item of this.filterGroup.items) {
            if (item.id !== this.ALL_FILTER_ID) {
              if (item.selected) {
                displayCount += 1
                displayFilterArr.push(item)
              }
            }
          }
          if (displayCount === 0) {
            if (this.filterGroup.title === 'Location') {
              if (this.getUserLocation) {
                try {
                  displayFilterArr.push(this.filterGroup.items.find(o => o.id === this.resolveCountryId()))
                } catch (err) {
                  displayFilterArr.push(this.filterGroup.items.find(o => o.id === 'all'))
                }
              }
            } else {
              displayFilterArr = this.filterGroup.items.slice(1, 5) // starting at 1 to avoid adding the all selected option
            }
          }
          return displayFilterArr
        },
        filterTitle() {
          switch (this.filterGroup.title) {
            case 'Grades':
              return (this.defaultLang) ? this.$t('general.grades') : this.$t('general.ages')
            case 'Subjects':
              return this.$t('general.subjects')
            case 'Resource Type':
              return this.$t('general.resourceType')
            case 'Location':
              return this.$t('general.location')
            case 'Standards':
              return this.$t('general.standard')
          }
        },
        defaultLang() {
          return this.$i18n.locale === 'en' || this.$i18n.locale === 'en-US'
        },
        selectedStandard() {
          let standard = this.getStandards.find(x => x.selected === true && x.id !== 'none')
          let selectedStandard = []
          if (standard) {
            selectedStandard.push(standard.title)
          }
          return selectedStandard
        },
        resolveStrands() {
          if (this.strands.length > 0) {
            return this.strands
          } else {
            return this.getStrands
          }
        }
      },
      watch: {
        selectedFilterCount: function (newVal, oldVal) {
          if (newVal === 0) {
            this.setDefaultFilterGroup({filters: this.filters, filterGroup: this.filterGroup.title})
          }
        }
      },
      directives: {
        ClickOutside
      }
    }
</script>

<style lang="scss" scoped>
  @import '../../../../../src/styles/colours.scss';
  @import '../../../../../src/styles/breakpoints';

  hr {
    background: $slate;
    opacity: 0.2;
    height: 2px;
  }

  .activity-icons {
    height: 30px;
    width: 30px;
  }

  .bottom-margin {
    margin-bottom: 14px;
  }

  .filter-heading {
    height: 30px;
    margin-bottom: 16px;
  }

  .filter-options {
    font-size: 15px;
    padding-left: 5px;
  }

  .filter-title {
    font-size: 18px;
    color: $content-text;
    line-height: 30px;
    padding-left: 5px;
  }

  .lrg-checkbox {
    height: 29px;
    width: 29px;
  }

  .options-padding {
    padding-bottom: 14px;
  }

  .see-more-triangle {
    color: $light-blue;
    cursor: pointer;
  }

  .see-more-text {
    color: $content-link-blue;
    cursor: pointer;
    font-size: 14px;
    padding-top: 14px;
  }

  .std-checkbox {
    height: 22px;
    width: 22px;
  }

  .standards-error-box {
    border-radius: 8px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
    background-color: $lighter-grey;
  }

  .error-heading {
    padding-left: 5px;
    padding-top: 13px;
    font-size: 18px;
    color: $content-text;
  }

  .error-message {
    padding: 17px 20px 32px;
    font-size: 14px;
    color: $content-text;
    line-height: 1.36;
    letter-spacing: normal;
  }

  .warning-icon-container {
    margin-left: 10px;
    width: 25px;
    height: 25px;
  }

  .uk-align-left {
    margin-right: 20px;
    margin-bottom: 17px;
  }

  @media screen and (max-width: $breakpoint-large) {
    .error-heading {
      font-size: 15px;
    }

    .error-message {
      font-size: 11px;
    }

    .warning-icon-container {
      margin-left: 5px;
    }
  }


</style>
